import { OwnOpponnentSwitcherWrapper } from "./EventSharedStyles";

const OwnOpponentSwitcher = ({
  value,
  onChange,
  ownLabel,
  opponentLabel,
}) => {
  return (
    <OwnOpponnentSwitcherWrapper>
      <div
        className={`tabItem ${value === "own" ? "active" : ""}`}
        onClick={() => onChange?.("own")}
      >
        {ownLabel}
      </div>
      <div
        className={`tabItem ${value === "opponent" ? "active" : ""}`}
        onClick={() => onChange?.("opponent")}
      >
        {opponentLabel}
      </div>
    </OwnOpponnentSwitcherWrapper>
  );
};

export default OwnOpponentSwitcher;
